var _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTerminalPlaceholder = function SvgTerminalPlaceholder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 71.111,
    viewBox: "0 0 40 71.111",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.5,0h-35A2.5,2.5,0,0,0,112,2.5V68.611a2.5,2.5,0,0,0,2.5,2.5h35a2.5,2.5,0,0,0,2.5-2.5V2.5A2.5,2.5,0,0,0,149.5,0ZM117,62.222V8.889h30V62.222Z",
    transform: "translate(-112)",
    fill: "#a4afb7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.346,176A1.346,1.346,0,0,0,408,177.346V183.5a1.346,1.346,0,1,0,2.692,0v-6.154A1.346,1.346,0,0,0,409.346,176Z",
    transform: "translate(-390.692 -168.308)",
    fill: "#a4afb7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.346,176A1.346,1.346,0,0,0,48,177.346V183.5a1.346,1.346,0,1,0,2.692,0v-6.154A1.346,1.346,0,0,0,49.346,176Z",
    transform: "translate(-48 -168.308)",
    fill: "#a4afb7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,176v9.231a1.538,1.538,0,0,0,1.538,1.538h.962v3.269a1.346,1.346,0,0,0,2.692,0v-3.269H131.5v3.269a1.346,1.346,0,0,0,2.692,0v-3.269h.962a1.538,1.538,0,0,0,1.538-1.538V176Z",
    transform: "translate(-120.346 -168.308)",
    fill: "#a4afb7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.577,
    cy: 0.577,
    r: 0.577,
    transform: "translate(6.538 3.846)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.577,
    cy: 0.577,
    r: 0.577,
    transform: "translate(12.308 3.846)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.587,21.769a5.925,5.925,0,0,0-2.607-3.4q-.107-.066-.216-.129l-.22-.123.244-.437.764-1.378a.2.2,0,0,0-.079-.275.2.2,0,0,0-.1-.025.2.2,0,0,0-.177.1l-.774,1.4-.244.44q-.115-.051-.234-.1c-.079-.03-.158-.061-.238-.089a6.88,6.88,0,0,0-4.567,0q-.12.043-.238.089l-.234.1-.244-.44-.774-1.394a.2.2,0,0,0-.355.2l.76,1.375.244.437q-.112.059-.221.121t-.215.131a5.925,5.925,0,0,0-2.606,3.4,4.542,4.542,0,0,0-.179,1.154h12.686A4.542,4.542,0,0,0,136.587,21.769ZM127.538,21a.577.577,0,1,1,.577-.577A.577.577,0,0,1,127.538,21Zm5.769,0a.577.577,0,1,1,.577-.577A.577.577,0,0,1,133.307,21Z",
    transform: "translate(-120.422 -16)",
    fill: "#a4afb7"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTerminalPlaceholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/terminalPlaceholder.2e617671.svg";
export { ForwardRef as ReactComponent };